<template>
  <v-layout row justify-center>
    <v-dialog v-model="params.show" max-width="600px" persistent>
      <v-form id="newDarfPaymentForm">
        <v-card>
          <v-card-title>
            <span class="headline">Novo Pagamento DARF</span>
          </v-card-title>
          <v-card-text>
            <div class="mb-3">
              <h4>Documento de Arrecadação de Receitas Federais</h4>
            </div>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="CNPJ/CPF*"
                    v-model="params.darf_payment.cnpj_cpf"
                    persistent-hint
                    hint="CNPJ (14 dígitos) ou CPF (11 dígitos) do contribuinte"
                    required
                    :mask="getCnpjCpfMask()"
                    :rules="[params.rules.required, params.rules.cnpjCpfValidation]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="codigosReceita"
                    v-model="params.darf_payment.codigo_receita"
                    label="Código da Receita*"
                    item-text="label"
                    item-value="value"
                    persistent-hint
                    hint="Selecione o código da receita federal"
                    :rules="[params.rules.required]"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Nome da Empresa/Contribuinte*"
                    v-model="params.darf_payment.nome_empresa"
                    persistent-hint
                    hint="Nome ou razão social do contribuinte"
                    :rules="[params.rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Descrição*"
                    v-model="params.darf_payment.descricao"
                    persistent-hint
                    hint="Descrição do pagamento DARF"
                    :rules="[params.rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Valor Principal*"
                    v-model.lazy="params.darf_payment.valor_principal"
                    v-money="money" 
                    :rules="[params.rules.required, params.rules.amountValidation]"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Valor Multa"
                    v-model.lazy="params.darf_payment.valor_multa"
                    v-money="money" 
                    hint="Valor da multa (opcional)">
                  </v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Valor Juros"
                    v-model.lazy="params.darf_payment.valor_juros"
                    v-money="money" 
                    hint="Valor dos juros (opcional)">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Referência*"
                    v-model="params.darf_payment.referencia"
                    persistent-hint
                    hint="Número de referência do pagamento (ex: DARF-202507)"
                    :rules="[params.rules.required]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-menu
                    v-model="periodoApuracaoMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="periodoApuracaoFormatted"
                        label="Período de Apuração*"
                        persistent-hint
                        hint="Mês/Ano de referência do tributo (MM/AAAA)"
                        readonly
                        v-on="on"
                        :rules="[params.rules.required]"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="params.darf_payment.periodo_apuracao"
                      type="month"
                      locale="pt-br"
                      @input="periodoApuracaoMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <h4>Data de Vencimento*</h4>
                  <v-date-picker
                    v-model="params.darf_payment.data_vencimento"
                    locale="pt-br"
                    :landscape="true"
                    :reactive="true"
                    :rules="[params.rules.required]"
                    required
                  ></v-date-picker>
                </v-flex>
                <small>*campos requeridos</small>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="params.show = false">Fechar</v-btn>
            <v-btn
              color="primary"
              :loading="params.loadingButton"
              @click="submitNewDarfPayment"
            >Enviar Pagamento</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="params.darfDialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline success--text">
          <v-icon color="success" class="mr-2">check_circle</v-icon>
          Pagamento DARF Enviado com Sucesso
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="body-1 mb-3">
            Seu pagamento DARF foi enviado para processamento e aparecerá na listagem abaixo.
          </p>
          <p class="body-2 grey--text">
            O status será atualizado automaticamente conforme o processamento. 
            Em caso de inconsistência nos dados, o valor será estornado automaticamente.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="params.darfDialog = false">
            <v-icon left>thumb_up</v-icon>
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="params.darfDialogErrors" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Erro ao processar pagamento DARF</v-card-title>
        <v-card-text v-if="!erroMessage">
          Erro ao processar seu pagamento DARF. Verifique se a operação está habilitada,
          se você tem saldo na sua conta digital e se todos os campos estão corretos,
          ou entre em contato com a {{ appName }}.
        </v-card-text>
        <v-card-text v-else>{{erroMessage}}</v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            block
            center
            @click="params.darfDialogErrors = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";
import { changed } from '@/helpers/layout';
import { VMoney } from 'v-money';
import { mask } from 'vue-the-mask';

export default {
  name: "NewDarfPaymentForm",
  created() {
    EventBus.$on("show-new-darf-payment-form", () => {
      this.params.show = true;
    });
    this.$store.dispatch("system/fetchSystemConfiguration");
  },
  computed: {
    ...mapGetters({
      createdDarf: "bills/darfPayment",
      darfErrors: "bills/darfPaymentError",
      systemAppName: "system/appName",
      account: "account/account",
    }),
    appName() {
      return this.systemAppName || process.env.VUE_APP_APP_NAME || 'FlowIt';
    },
    paymentProvider() {
      return (this.account && this.account.bill_source) || 'banco_inter';
    },
    periodoApuracaoFormatted: {
      get() {
        if (!this.params.darf_payment.periodo_apuracao) return '';
        const [year, month] = this.params.darf_payment.periodo_apuracao.split('-');
        return `${month}/${year}`;
      },
      set(value) {
        // Not used, as we use the date picker
      }
    }
  },
  watch: {
    createdDarf(newValue, oldValue) {
      this.params.darfDialog = true;
      this.params.show = false;
      this.params.loadingButton = false;
      // Atualizar listagem de pagamentos após sucesso
      this.$store.dispatch('bills/loadDarfsPayment', this.$store.getters['bills/darfsPaymentFilter']);
      // Limpar formulário para novos pagamentos
      this.resetForm();
    },
    darfErrors(newValue, oldValue) {
      if (newValue && newValue.errors && newValue.errors.length > 0) {
        this.params.darfDialogErrors = true;
        this.params.show = false;
        this.params.loadingButton = false;
        this.erroMessage = newValue.errors[0]['response_code_detail'] || 'Erro desconhecido';
      }
    }
  },
  data: () => ({
    erroMessage: false,
    periodoApuracaoMenu: false,
    codigosReceita: [
      { label: '0220 - IRRF Autônomo', value: '0220' },
      { label: '0561 - COFINS', value: '0561' },
      { label: '0588 - PIS/PASEP', value: '0588' },
      { label: '0648 - CSLL', value: '0648' },
      { label: '2362 - IRPJ Estimativa Mensal', value: '2362' },
      { label: '6211 - IRRF Serviços', value: '6211' },
      { label: '5952 - INSS Empregado', value: '5952' },
      { label: '2991 - FGTS', value: '2991' }
    ],
    params: {
      show: false,
      darfDialog: false,
      darfDialogErrors: false,
      loadingButton: false,
      darf_payment: {
        cnpj_cpf: "",
        codigo_receita: "",
        data_vencimento: new Date().toISOString().substr(0, 10),
        nome_empresa: "",
        descricao: "",
        valor_principal: "",
        valor_multa: "",
        valor_juros: "",
        referencia: "",
        periodo_apuracao: new Date().toISOString().substr(0, 7)
      },
      rules: {
        required: value => !!value || "Campo obrigatório",
        cnpjCpfValidation: value => {
          if (!value) return "Campo obrigatório";
          const cleanValue = value.replace(/[^0-9]/g, '');
          return (cleanValue.length === 11 || cleanValue.length === 14) || 
                 "CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos";
        },
        amountValidation: value => {
          if (!value) return "Campo obrigatório";
          const numValue = parseFloat(value.toString().replace(/[^\d,]/g, '').replace(',', '.'));
          return numValue > 0 || "Valor deve ser maior que zero";
        },
      },
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    },
  }),
  directives: {money: VMoney, mask},
  methods: {
    submitNewDarfPayment() {
      // Validação básica antes do envio
      if (!this.params.darf_payment.cnpj_cpf || 
          !this.params.darf_payment.codigo_receita ||
          !this.params.darf_payment.nome_empresa ||
          !this.params.darf_payment.descricao ||
          !this.params.darf_payment.valor_principal || 
          !this.params.darf_payment.data_vencimento) {
        this.erroMessage = "Por favor, preencha todos os campos obrigatórios";
        this.params.darfDialogErrors = true;
        return;
      }

      this.new_params = {
        cnpj_cpf: this.params.darf_payment.cnpj_cpf.replace(/[^0-9]/g, ''),
        codigo_receita: this.params.darf_payment.codigo_receita,
        data_vencimento: this.params.darf_payment.data_vencimento,
        nome_empresa: this.params.darf_payment.nome_empresa,
        descricao: this.params.darf_payment.descricao,
        valor_principal: parseFloat(this.params.darf_payment.valor_principal.replace(/[^\d]+/g,''))/100,
        valor_multa: this.params.darf_payment.valor_multa ? parseFloat(this.params.darf_payment.valor_multa.replace(/[^\d]+/g,''))/100 : 0,
        valor_juros: this.params.darf_payment.valor_juros ? parseFloat(this.params.darf_payment.valor_juros.replace(/[^\d]+/g,''))/100 : 0,
        referencia: this.params.darf_payment.referencia,
        periodo_apuracao: this.params.darf_payment.periodo_apuracao
      }
      
      const response = this.$store.dispatch(
        "bills/newDarfPayment",
        this.new_params
      );
      this.params.loadingButton = true;
    },
    resetForm() {
      this.params.darf_payment = {
        cnpj_cpf: "",
        codigo_receita: "",
        data_vencimento: new Date().toISOString().substr(0, 10),
        nome_empresa: "",
        descricao: "",
        valor_principal: "",
        valor_multa: "",
        valor_juros: "",
        referencia: "",
        periodo_apuracao: new Date().toISOString().substr(0, 7)
      };
    },
    getCnpjCpfMask() {
      if (!this.params.darf_payment.cnpj_cpf) {
        return "###.###.###-##"; // Máscara padrão CPF
      }
      
      const cleanValue = this.params.darf_payment.cnpj_cpf.replace(/[^0-9]/g, '');
      
      if (cleanValue.length <= 11) {
        return "###.###.###-##"; // CPF
      } else {
        return "##.###.###/####-##"; // CNPJ
      }
    }
  }
};
</script>

<style scoped>
.v-card {
  border-radius: 8px !important;
}

.v-card-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white !important;
}

.v-card-title .headline {
  color: white !important;
}

.v-text-field {
  margin-bottom: 8px;
}

.v-btn.primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
}

.v-date-picker {
  border-radius: 8px;
}

.mb-3 h4 {
  color: #333;
  font-weight: 500;
  margin-bottom: 8px;
}
</style>